import React, { useEffect, useState } from 'react';
import TimePicker from 'react-times';
import axios from 'axios';
import axios2 from '../axiosConfig';
import '../css/footer.css';
import { handleError, toastError } from '../funciones';
import ojoAbierto from '../assets/ojoAbierto.svg';
import ojoCerrado from '../assets/ojoCerrado.svg';
import Calendario from './Calendario';


function FormInput(props) {

    const [unionLaboral, setUnionLaboral] = useState([]);
    const [contraseñaVisible, setContraseñaVisible] = useState(false);

    function corregido(id, setValue, setText) {
        const elem = document.getElementById(id);
        if (setText !== undefined)
            setText(elem.options[elem.value].text)
        if (setValue !== undefined)
            if (id !== "mesas")
                setValue(elem.value)
            else {
                const selectedMesa = unionLaboral.find(m => m.id === elem.value);
                if (selectedMesa !== null) setValue(selectedMesa)
                else setValue({ id: "", numeroDeMesa: "0" })
            }


        if (elem.classList.contains("texBoxError"))
            elem.classList.remove("texBoxError");
    }
    useEffect(() => {
        props.value && props.id && document.getElementById(props.id)?.classList.remove("texBoxError");
    }, [props.value]);
    
    function cambioHora(options) {
        props.setHora(options.hour + ":" + options.minute);
    }
    function mostrarCalendario(id) {
        document.getElementById("calendario-" + id).classList.remove("d-none");
    }
    useEffect(() => {
        if (props.idSeccion === 0) {

            axios
                .get(process.env.REACT_APP_URL + 'empresa/getAllUnionesIndustriales')
                .then(function (response) {
                    if (props.mostrarTodas)
                        setUnionLaboral(response.data);
                    else
                        setUnionLaboral(response.data.filter(union => union !== "Todas"));

                })
                .catch(function (error) {
                    toastError(handleError(error))
                });
        }

    }, []);

    useEffect(() => {
        if (props.idSeccion === 8 && props.reload !== undefined) {
            axios2
                .get(process.env.REACT_APP_URL + props.url, props.params)
                .then(function (response) {
                    setUnionLaboral(response.data);

                    if ((props.id === "eventos") && response.data.length > 0)
                        props.setValue(response.data[0].id)
                    else if ((props.id === "mesas" || props.id === "mesasFijas") && response.data.length > 0) {
                        props.setValue(response.data[0])
                    } else if (props.isText && response.data.length > 0)
                        props.setValue(response.data[0])
                })
                .catch(function (error) {
                    toastError(handleError(error))
                });
        }
    }, [props.params, props.reload]);

    useEffect(() => {
        if (props.idSeccion === 10) {
            if ((props.id === "empresa1" || props.id === "empresa2") && props.items.length > 0)
                props.setValue(props.items[0].inscripcionView.id)
            else if (props.id === "empresaFiltroId" || props.id === "horarioFiltro")
                props.setValue("")
            else if (props.id === "horario" && props.items.length > 0)
                props.setValue(props.items[0])
        }
    }, [props.items]);

    function formatearFecha(fechaInicial) {
        const date = new Date(fechaInicial);
        date.setDate(date.getDate() + 1);
        return new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
    }

    return (
        props.idSeccion === undefined ? (
            <div className={props.className + (props.disabled ? " opacity-mobile" : "")}>
                <div class="mb-3">
                    <label for={props.id} class="form-label letraDatos">{props.text}</label>
                    <div id={props.idSeccion + "Helper"} class={"form-text textoErrores ms-1 " + (props.helper ? 'd-inline' : '')}>{props.helper}</div>
                    <input type={props.type} class={"form-control letraDatos"} disabled={props.disabled} id={props.id} aria-describedby="emailHelp"
                        onChange={() => corregido(props.id, props.setValue)} placeholder={props.placeholder} value={props.value} />
                </div>
            </div>
        ) : props.idSeccion === 0 ? (
            <div className={props.className}>
                <div class="mb-3">
                    <label for={props.id} class="form-label letraDatos">{props.text}</label>
                    <select id={props.id} value={props.value} aria-describedby="uniones" class="form-select letraDatos" aria-label="Default select example"
                        onChange={() => corregido(props.id, props.setValue, props.setText)}>
                        {unionLaboral.map((union, index) => (
                            <option value={index}>{union}</option>
                        ))}
                    </select>
                    <div id="emailHelp" class="form-text textoErrores">We'll never share your email with anyone else.</div>
                </div>
            </div>

        ) : props.idSeccion === 1 ? (
            <div className={props.className}>
                <div class="mb-3 h-100">
                    <label for={props.id} class="form-label letraDatos ">{props.text}</label>
                    <textarea class="form-control formDescripcion letraDatos" id={props.id} rows="3" onChange={() => corregido(props.id)}></textarea>
                </div>
            </div>
        ) : props.idSeccion === 3 ? (
            <div className={props.className + (props.disabled ? " opacity-mobile" : "")}>
                <div class="mb-3 h-100">
                    <label for={props.id} class="form-label letraDatos " >{props.text}</label>
                    <div className={'form-control altura-hora' + (props.disabled ? ' formTimerDisabled' : '')} >
                        <TimePicker
                            onTimeChange={cambioHora.bind(this)}
                            time={props.hora}
                            limitDrag
                            disabled={props.disabled}
                        />
                    </div>
                </div>
            </div>
        ) : props.idSeccion === 4 ? (
            <div className={props.className}>
                <div class="form-check form-switch ">
                    <input class="form-check-input cursor-pointer" type="checkbox" id={props.id} checked={props.value} onChange={() => props.setValue(!props.value)} disabled={props.disabled} />
                    <label class="form-check-label letraDatos cursor-pointer" for={props.id}>{props.text}</label>
                </div>
            </div>
        ) : props.idSeccion === 5 ? (
            <>
                <div className={props.className}>
                    <div class="mb-3 cursor-pointer">
                        <label for={props.id} class="form-label letraDatos">{props.text}</label>
                        <div type={props.type} class={"form-control letraDatos"} disabled={props.disabled} id={props.id} aria-describedby="emailHelp"
                            onClick={() => mostrarCalendario(props.id)} >{formatearFecha(props.fecha)}</div>
                        <div id="emailHelp" class="form-text textoErrores ">We'll never share your email with anyone else.</div>

                    </div>
                </div>
                <Calendario setFecha={props.setFecha} id={props.id} restart={props.restart} isSetDate={props.isSetDate} fecha={props.fecha} />
            </>
        ) : props.idSeccion === 6 ? (
            <>
                <div className={props.className}>
                    <label class="form-label letraDatos " >{props.text}</label>

                    {props.opcionesText.length !== 0 ?
                        props.opcionesText.map(function (elem, i) {
                            return (
                                <div class="form-check ">
                                    <input class="form-check-input cursor-pointer" type="radio" name={props.id} id={props.id + i} value={elem}
                                        checked={props.value === elem}

                                        onChange={() => props.setValue(elem)} />
                                    <label class="form-check-label cursor-pointer" for={props.id + i}>{/*checked={props.value === elem}*/}
                                        {elem}
                                    </label>
                                </div>
                            );
                        })
                        :
                        <></>
                    }
                </div>
            </>
        ) : props.idSeccion === 7 ? (
            <>
                <div className={props.className}>
                    <div class="mb-3">
                        <label for={props.id} class="form-label letraDatos">{props.text}</label>
                        <select id={props.id} value={props.value} aria-describedby="uniones" class="form-select letraDatos" aria-label="Default select example"
                            onChange={() => corregido(props.id, props.setValue)}>
                            {props.items.map((label, index) => (
                                <option value={index}>{label}</option>
                            ))}
                        </select>
                        <div id="emailHelp" class="form-text textoErrores">We'll never share your email with anyone else.</div>
                    </div>
                </div>
            </>
        ) : props.idSeccion === 8 ? (//Hace la query y arma un select basado en ella
            <div className={props.className}>
                <div class="mb-3">
                    <label for={props.id} class="form-label letraDatos">{props.text}</label>
                    <select id={props.id} value={props.id === "mesasFijas" && props.value} aria-describedby="uniones" class="form-select letraDatos" aria-label="Default select example"
                        onChange={() => corregido(props.id, props.setValue, props.setText)} >
                        {unionLaboral.map((elem) => (
                            !props.isText ? (
                                props.id === "mesas" ? (
                                    <option value={elem.id}>{elem.numeroDeMesa}</option>
                                ) : props.id === "mesasFijas" ? (
                                    <option value={elem.numeroDeMesa}>{elem.numeroDeMesa}</option>
                                ) : props.id === "empresa1" || props.id === "empresa2" ? (
                                    <option value={elem.inscripcionView.id}>{elem.empresaPerfilFullView.nombre}</option>
                                ) : (
                                    <option value={elem.id}>{elem.nombre}</option>
                                )
                            ) : (
                                <option value={elem}>{elem}</option>
                            )

                        ))}
                        {unionLaboral.length === 0 && props.id === "mesas" ?
                            <option value="">0</option>
                            : unionLaboral.length === 0 && (props.id === "empresa1" || props.id === "empresa2") ?
                                <option value="-1">No Posee empresas</option>
                                : unionLaboral.length === 0 && (props.id === "mesasFijas") ?
                                    <option value="">No hay mesas disponibles</option>
                                    :
                                    <></>
                        }
                    </select>
                    <div id="emailHelp" class="form-text textoErrores">We'll never share your email with anyone else.</div>
                </div>
            </div>
        ) : props.idSeccion === 9 ? (
            <div className={props.className + (props.disabled ? " opacity-mobile" : "")}>
                <div class="mb-3">
                    <label for={props.id} class="form-label letraDatos">{props.text}</label>
                    <div className='position-relative'>
                        <input type={contraseñaVisible ? 'text' : 'password'} class={"form-control letraDatos contraseña"} disabled={props.disabled} id={props.id} aria-describedby="emailHelp"
                            onChange={() => corregido(props.id, props.setValue)} >
                        </input>
                        <img id={'mostrar' + props.id} className={'position-absolute imgMostrarContraseña cursor-pointer mobile-white'} onClick={() => setContraseñaVisible(!contraseñaVisible)}
                            src={contraseñaVisible ? ojoCerrado : ojoAbierto} />
                    </div>
                    <div id="emailHelp" class="form-text textoErrores ">We'll never share your email with anyone else.</div>
                </div>
            </div>
        ) : props.idSeccion === 10 ? (//recibe una lista y arma un select basado en ella
            <div className={props.className + (props.disabled ? " opacity-mobile" : "")}>
                <div class="mb-3">
                    <label for={props.id} class="form-label letraDatos">{props.text}</label>
                    <select id={props.id} value={props.value} aria-describedby="uniones" class="form-select letraDatos" aria-label="Default select example"
                        onChange={() => corregido(props.id, props.setValue, props.setText)} disabled={props.disabled}>
                        {
                            props.id === "empresaFiltroId" || props.id === "mesaFiltro" ?
                                <option value="">Todas</option>
                                : props.id === "horarioFiltro" ?
                                    <option value="">Todos</option>
                                    :
                                    <></>
                        }
                        {props.items.map((elem) => (
                            !props.isText ? (
                                props.id === "mesas" ? (
                                    <option value={elem.id}>{elem.numeroDeMesa}</option>
                                ) : props.id === "empresa1" || props.id === "empresa2" ? (
                                    <option value={elem.inscripcionView.id}>{elem.empresaPerfilFullView.nombre}</option>
                                ) : props.id === "empresaFiltroId" ? (
                                    <option value={elem.empresaPerfilFullView.id}>{elem.empresaPerfilFullView.nombre}</option>
                                ) : (
                                    <option value={elem.id}>{elem.nombre}</option>
                                )
                            ) : (
                                <option value={elem}>{elem}</option>
                            )

                        ))}
                        {props.items.length === 0 && props.id === "mesas" ?
                            <option value="">0</option>
                            : props.items.length === 0 && (props.id === "empresa1" || props.id === "empresa2") ?
                                <option value="-1">No Posee empresas</option>
                                : <></>
                        }
                    </select>
                    <div id="emailHelp" class="form-text textoErrores">We'll never share your email with anyone else.</div>
                </div>
            </div>
        ) : (
            <div className={props.className}>
                <div class="mb-3">
                    <input type={props.type} class="form-control letraDatos" id={props.id} aria-describedby="emailHelp"
                        onChange={() => corregido(props.id)} placeholder={props.placeholder} />
                    <div id="emailHelp" class="form-text textoErrores ">We'll never share your email with anyone else.</div>
                </div>
            </div>
        )

    );
}


export default FormInput;